(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
if (!customElements.get('search-auto-pages')) {
  customElements.define('search-auto-pages', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.closest('#product-grid');
      this.list = this.grid?.querySelector('ul.product-grid');
      this.fallback = this.querySelector('[data-search-pagination]');
      this.status = this.querySelector('[data-search-loading]');
      this.nextUrl = this.dataset.nextUrl;
      this.busy = false;
      this.failed = false;
      this.visited = new Set();
      if (!this.list || !this.nextUrl || !('IntersectionObserver' in window)) return;
      this.fallback.hidden = true;
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
      }, { rootMargin: '0px 0px 600px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }

    async loadNext() {
      if (this.busy || this.failed || !this.nextUrl || !this.isConnected) return;
      this.busy = true;
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 20000);
      this.status.hidden = false;
      this.list.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.nextUrl, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Invalid search URL');
        url.searchParams.set('section_id', this.dataset.sectionId);
        if (this.visited.has(url.href)) throw new Error('Repeated search page');
        const response = await fetch(url.href, { signal: controller.signal });
        if (!response.ok) throw new Error('Search request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || controller !== this.controller) return;
        const nextGrid = html.querySelector('#product-grid');
        const nextList = nextGrid?.querySelector('ul.product-grid');
        const items = nextList ? Array.from(nextList.children) : [];
        if (!items.length) throw new Error('Search results missing');
        const nextPager = nextGrid.querySelector('search-auto-pages');
        const nextFallback = nextPager?.querySelector('[data-search-pagination]');
        items.forEach((item) => {
          [item, ...item.querySelectorAll('.scroll-trigger')].forEach((element) => {
            element.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in', 'animate--fade-in');
            element.removeAttribute('data-cascade');
          });
        });
        this.list.append(...items);
        this.visited.add(url.href);
        this.nextUrl = nextPager?.dataset.nextUrl || '';
        if (nextFallback) this.fallback.innerHTML = nextFallback.innerHTML;
        if (!this.nextUrl) this.observer.disconnect();
      } catch (error) {
        if (!this.isConnected || controller !== this.controller) return;
        this.failed = true;
        this.observer.disconnect();
        this.fallback.hidden = false;
      } finally {
        clearTimeout(timeout);
        if (controller === this.controller) {
          this.busy = false;
          this.status.hidden = true;
          this.list.removeAttribute('aria-busy');
        }
      }
      if (this.isConnected && this.nextUrl && !this.failed) {
        this.observer.unobserve(this);
        this.observer.observe(this);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
